module.exports = __webpack_public_path__ + "media/confirmation.ed44080c.svg";